module.exports = __webpack_public_path__ + "img/sancor_seguros.35fa39ef.png";